// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 5279 ? "6c44d60f" : chunkId) + "." + {"5279":"12568ce00316cad1","7229":"d186423241f8b9c3"}[chunkId] + ".js";
};